/*
 * @Author: Michael 
 * @Date: 2017-12-15 10:09:57 
 * @Last Modified by: Michael
 * @Last Modified time: 2017-12-18 18:08:21
 */
<template>
  <div class="xm-navbar">
    <span class="navbar-title">{{navbarTitle}}</span>
  </div>
</template>

<script>
export default {
  name: "xm-navbar",
  props: ["navbarTitle"]
};
</script>

<style lang="less">
.xm-navbar {
  height: 1rem;
  display: flex;
  align-items: center;
  padding-left: 0.3rem;
  font-size: 0.32rem;
  background: #ffffff;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: auto;
    height: 1px;
    width: 100%;
    background-color: #eee;
    display: block;
    z-index: 1;
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
  }
  .navbar-title {
    font-size: 0.34rem;
    font-weight: 500;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Navbar.vue